var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price"},[_c('h1',{staticClass:"hit-html-h1"},[_vm._v(_vm._s(_vm.$t('message.price')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }